<template>
  <div v-if="wrapshow">
    <!-- :style="{ height: '80%' }" -->
    <van-popup v-model="open" position="bottom" @closed="wrapshow = false">
      <van-picker
        show-toolbar
        title="选择学员性别"
        value-key="name"
        :default-index="defaultIndex"
        :columns="sex"
        @confirm="confirm"
        @cancel="close"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'GradePicker',
  data() {
    return {
      wrapshow: true,
      open: false,
      //   选中的id
      choosedGenderId: "",
      // 性别数据 
      sex: [
        { name: "女", id: 0 },
        { name: "男", id: 1 },
      ],
    };
  },
  computed: {
    //   选中的索引
    defaultIndex () {
      if (this.choosedGenderId === "") return ""
      let idx = this.sex.findIndex(v => v.id === this.choosedGenderId);
      return idx
    }
  },
  methods: {

    showPicker(opts = {}) {
      return new Promise((resolve) => {
        this.wrapshow = true;
        this.open = true;
        this.choosedGenderId = opts.id || 0;

        this._resolve = resolve;
      });
    },
    close(e) {
      this.open = false;
    },
    confirm(e) {
      this.close();
      this._resolve(e);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped></style>
